import {useEffect} from 'react';

import {useGetAutoDeliveryDetailsExtendedDcx} from '@/api/consumerApi';
import AppLoader from '@/components/Loader/AppLoader/AppLoader';
import routerService from '@/services/route/routerService';

import {useAutoDeliveryDcxContext} from './AutoDeliveryDcxContext';
import SkipDelivery from './AutoDeliveryDcxDetailsPages/SkipDelivery/SkipDelivery';

const AutoDeliveryDcxSkipPage = () => {
    const {setDetailsRefetchDisabled} = useAutoDeliveryDcxContext();

    useEffect(() => {
        setDetailsRefetchDisabled(true);
    }, []);

    const {data, isLoading, isFetching, isError} = useGetAutoDeliveryDetailsExtendedDcx();

    // @ts-expect-error AppLoader is a JS component without proper type definitions
    if (isLoading || isFetching || !data) return <AppLoader />;
    if (isError) {
        routerService.goBack();
        return null;
    }

    return <SkipDelivery />;
};

export default AutoDeliveryDcxSkipPage;
